var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.addClass,attrs:{"disabled":this.isLoading || this.isDisabled,"id":_vm.id,"type":_vm.type},on:{"click":_vm.onClick}},[_vm._t("default"),(this.isLoading)?_c('base-icon',{staticClass:"loader-icon",attrs:{"name":"loader"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }